import React from 'react';
import NextError from 'next/error';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { checkUrl } from '../helpers';
import { ContentContainer, PageBuilderPreviewContainer } from '../containers';
import { NOT_FOUND_STATUS_CODE, RESOLVER_CONTAINER_CLASS } from '../constants';

const Resolver = props => {
  const {
    pageData,
    itemId,
    itemEntity,
    isStatusPage,
    fullUrl,
    disableSsr,
    rootSelectorClasses = RESOLVER_CONTAINER_CLASS,
    isPreview = false,
    errorCode = NOT_FOUND_STATUS_CODE,
    errorMessage = null,
    redirecting = false
  } = props;

  const router = useRouter();

  if (disableSsr) {
    if (typeof window !== 'undefined') {
      let { asPath } = router;
      if (window.location.hash) {
        // handle nextjs issue not calling getInitialProps if pushing a url with a hash in it
        // we add a new query string param to force calling getInitialProps
        // this should only happen if disableSsr and window.location.hash
        const url = new URL(router.asPath, window.location.href);
        if (url.hash) url.searchParams.set('_h', Date.now());
        asPath = url;
      }

      router.push('/Resolver', asPath);
    }
    return '';
  }

  if (redirecting) return null;

  if (isStatusPage) return 'OK';

  const { pbPreviewData } = props;
  if (pbPreviewData) {
    return (
      <div className={rootSelectorClasses}>
        <PageBuilderPreviewContainer {...pbPreviewData} />
      </div>
    );
  }

  if (!pageData || !itemId || !itemEntity) {
    return (
      <div className="next_error">
        <NextError statusCode={errorCode} title={errorMessage} />
      </div>
    );
  }

  return (
    <div className={rootSelectorClasses}>
      <ContentContainer
        pageData={pageData}
        itemId={itemId}
        itemEntity={itemEntity}
        isPreview={isPreview}
        fullUrl={fullUrl}
      />
    </div>
  );
};

Resolver.getInitialProps = async props => checkUrl(props);

Resolver.propTypes = {
  pbPreviewData: PropTypes.object,
  itemId: PropTypes.string,
  itemEntity: PropTypes.string,
  pageData: PropTypes.object,
  isStatusPage: PropTypes.bool,
  fullUrl: PropTypes.string,
  isPreview: PropTypes.bool,
  errorCode: PropTypes.number,
  disableSsr: PropTypes.bool,
  errorMessage: PropTypes.string,
  rootSelectorClasses: PropTypes.string,
  redirecting: PropTypes.bool
};

Resolver.defaultProps = {
  pbPreviewData: null,
  itemId: null,
  itemEntity: null,
  pageData: null,
  isStatusPage: false,
  fullUrl: '',
  isPreview: false,
  errorCode: NOT_FOUND_STATUS_CODE,
  disableSsr: false,
  errorMessage: null,
  rootSelectorClasses: RESOLVER_CONTAINER_CLASS,
  redirecting: false
};

export default Resolver;
